// extracted by mini-css-extract-plugin
export default {"root":"Jy38SRwdPz4BLYZMHVYo","btn":"uwLia48yG7l44u_diF_n","submit":"W2Rr67SvpT9LMqLHn3aE","cancel":"Ojvl6feXk3DCfC4ovvVq"};